import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import React, { useEffect, useState } from 'react';
import { Row, Col, Alert, Container } from 'reactstrap';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { loginUser } from '../../store/actions';
import CarouselPage from '../AuthenticationInner/CarouselPage';
import getUrlParams from '../../components/Common/getUrlParams/getUrlParams';
import './index.scss';
import './auth-kit.scss';

interface LoginProps {
    history: object;
}

const Login = ({ history }: LoginProps) => {
    const dispatch = useDispatch();
    const { url, brand, result } = getUrlParams({ name: 'nwkID' });
    const [remember, setRemember] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [ networkId, setNetworkId ] = useState(undefined)
    const { error } = useSelector((state: any) => ({ error: state.login.error, }));
    // "Remember me" recuerda solo el correo: la contraseña nunca se guarda en el navegador.
    const handleValidSubmit = (event: any, values: any) => {
        if (remember) {
            localStorage.setItem("rememberMe", JSON.stringify({ email: values.email }));
        } else {
            localStorage.removeItem("rememberMe");
        }
        if (networkId) {
            dispatch(loginUser(values, history, networkId));
        }
    };
    useEffect(()=>{
        setNetworkId(result)
    },[result])
    
    useEffect(() => {
        const getUser = localStorage.getItem("rememberMe");
        if (getUser) {
            try {
                const user = JSON.parse(getUser);
                setEmail(user.email || '');
                setRemember(true);
                // Versiones anteriores guardaban también la contraseña en texto plano: se borra.
                if (user.password) localStorage.setItem("rememberMe", JSON.stringify({ email: user.email }));
            } catch {
                localStorage.removeItem("rememberMe");
            }
        }
    }, [])


    return (
        <React.Fragment>
            <PageTitle>
                <title>Login | {brand.name}</title>
            </PageTitle>
            <div className="auth-page auth-kit">
                <Container fluid className="p-0">
                    <Row className="g-0">
                        <Col lg={4} md={5} className="col-xxl-3">
                            <div className="auth-full-page-content d-flex p-sm-5 p-4">
                                <div className="w-100">
                                    <div className="d-flex flex-column h-100">
                                        <div className="mb-4 mb-md-5 text-center">
                                            <Link to={url} className="d-block auth-logo">
                                                {<img src={brand.logo} alt="" height="60" />}
                                            </Link>
                                        </div>
                                        <div className="auth-content my-auto">
                                            <div className="text-center">
                                                <h5 className="mb-0">Welcome Back!</h5>
                                                <p className="text-muted mt-2">Sign in to continue to {brand.name}.</p>
                                            </div>
                                            <AvForm
                                                className="custom-form mt-4 pt-2"
                                                onValidSubmit={(e: any, v: any) => {
                                                    handleValidSubmit(e, v);
                                                }}
                                            >
                                                {error ? <Alert color="danger">{error}</Alert> : null}
                                                <div className="mb-3">
                                                    <AvField
                                                        name="email"
                                                        label="Email"
                                                        value={email}
                                                        onChange={(e: any) => setEmail(e.target.value)}
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        required
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <div className="mb-3">
                                                        <AvField
                                                            name="password"
                                                            label="Password"
                                                            value={password}
                                                            onChange={(e: any) => setPassword(e.target.value)}
                                                            type="password"
                                                            className="form-control"
                                                            required
                                                            placeholder="Enter Password"
                                                        />
                                                    </div>
                                                    { result ? <></>:<div className="mb-3">
                                                        <AvField
                                                            name="network Id"
                                                            label="Network ID"
                                                            value={networkId}
                                                            onChange={(e: any) => setNetworkId(e.target.value)}
                                                            type="network Id"
                                                            className="form-control"
                                                            required
                                                            placeholder="Enter Network ID"
                                                        />
                                                    </div>}
                                                </div>
                                                <div className="row mb-4">
                                                    <div className="col">
                                                        <div className="form-check">
                                                            <input onChange={() => { setRemember(!remember) }} checked={remember} className="form-check-input" type="checkbox" id="remember-check" />
                                                            <label className="form-check-label" htmlFor="remember-check">
                                                                Remember me
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mb-3">
                                                    <button className="btn btn-primary w-100 waves-effect waves-light" type="submit">
                                                        Log In
                                                    </button>
                                                </div>
                                            </AvForm>

                                            { }

                                            <div className="mt-5 text-center colorTextCompany">
                                                <p className="text-muted mb-0">
                                                    Don&apos;t have an account ?
                                                    <Link to={`/register${url}`} className="text-primary fw-semibold">
                                                        {' '}
                                                        Sign Up now{' '}
                                                    </Link>{' '}
                                                </p>
                                            </div>
                                            <div className="mt-3 text-center colorTextCompany">
                                                <p className="text-muted mb-0">
                                                    <Link to={`/auth-recoverpw${url}`} className="text-primary fw-semibold">
                                                        {' '}
                                                        Forgot password?{' '}
                                                    </Link>{' '}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mt-4 mt-md-5 text-center">
                                            <p className="mb-0">© {new Date().getFullYear() + ' ' + brand.name}.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <CarouselPage />
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Login);
